<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

const visible = ref(false)

const target = ref(null)

const showTooltip = () => {
  visible.value = true
}

const hideTooltip = () => {
  visible.value = false
}

onClickOutside(target, hideTooltip)
</script>

<template>
  <div class="tooltip__wrapper">
    <button class="tooltip" @click="showTooltip">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 11.5V16.5M12 7.51L12.01 7.499M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
          stroke="#767676"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <div ref="target" class="tooltip__body" :class="{ visible }">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.tooltip {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -10px;
    cursor: pointer;
  }

  &__wrapper {
    position: relative;
  }
  &__body {
    opacity: 0;
    position: absolute;
    z-index: 4;
    pointer-events: none;
    @extend %hover-transition;
    top: 100%;
    right: 8px;
    &.visible {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
